module.exports = __webpack_public_path__ + "static/media/spelling.24e70159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/spelling.svg
// module id = 187
// module chunks = 0